import { getCompany } from 'helpers/getCompanyVariables';

const company = getCompany();

const COMPANY_NAMES = {
  oneill: {
    fullName: "O'Neill Marketing",
    acronym: 'OM',
    short: "O'Neill"
  },
  sunshine: {
    fullName: 'Sunshine Life and Health Advisors',
    acronym: 'SLHA',
    short: 'Sunshine'
  }
};

const companyNames = COMPANY_NAMES[company] ?? {};

export default companyNames;
